export const API_URL = import.meta.env.DEV ? "" : (import.meta.env.VITE_API_URL ?? "");

export class ApiError extends Error {
  constructor(
    public status: number,
    public code: string,
  ) {
    super(`API error ${status}: ${code}`);
  }
}

export async function fetchApi<T>(path: string): Promise<T> {
  const res = await fetch(`${API_URL}${path}`);
  if (!res.ok) {
    const body = await res.json().catch(() => ({ error: "unknown" }));
    throw new ApiError(res.status, (body as { error?: string }).error ?? "unknown");
  }
  return res.json() as Promise<T>;
}
